/**
 * Branding of an unauthenticated page, supplied through route `data`.
 *
 * The old app shipped two near-identical login components to support the
 * Jetcrete white label (see CODEBASE_AUDIT.md); here one page and one shell
 * read this config instead, so a new brand is a route entry, not a copy.
 */
export interface BrandLogo {
  /** Root-relative path under `public/`. */
  src: { lightTheme: string; darkTheme: string };
  alt: string;
}

export interface PublicBrand {
  /** Selects the backdrop and panel gradients via a modifier class. */
  id: 'sci' | 'jetcrete';
  logos: BrandLogo[];
  showLanguageSelector: boolean;
}

export const SCI_BRAND: PublicBrand = {
  id: 'sci',
  logos: [
    {
      src: {
        lightTheme: 'images/logos/SCi-Logo-Navy.png',
        darkTheme: 'images/logos/SCi-Logo-White.png',
      },
      alt: 'Shotcrete Intelligence logo',
    },
  ],
  showLanguageSelector: false,
};

export const JETCRETE_BRAND: PublicBrand = {
  id: 'jetcrete',
  logos: [
    {
      src: {
        lightTheme: 'images/logos/SCi-Logo-Navy.png',
        darkTheme: 'images/logos/SCi-Logo-White.png',
      },
      alt: '21MT Shotcrete Intelligence logo',
    },
    {
      src: {
        lightTheme: 'images/logos/jetcrete-logo.jpg',
        darkTheme: 'images/logos/jetcrete-logo.jpg',
      },
      alt: 'Jetcrete logo',
    },
  ],
  showLanguageSelector: true,
};

/** Used when a route omits the brand. */
export const DEFAULT_BRAND = SCI_BRAND;
